/**
 * トップページ: 季節セクション
 */

import { adjustSlideButtonPosition } from '../utils';

/**
 * 現在の月から季節を取得
 * @returns {string} 季節のスラッグ
 */
function getCurrentSeason() {
  const month = new Date().getMonth() + 1;

  if (month >= 4 && month <= 5) return 'spring';
  if (month >= 6 && month <= 8) return 'summer';
  if (month >= 9 && month <= 11) return 'autumn';
  return 'winter'; // 12, 1, 2, 3
}

/**
 * 季節セクションの初期化
 * @param {jQuery} $ - jQuery
 */
export function initSeasons($) {
  const $buttons = $('.s-home__seasons-btn');

  if ($buttons.length === 0) return;

  // ボタンクリックイベント
  $buttons.on('click', function () {
    const season = $(this).data('season');
    const $currentItem = $('.s-home__seasons-item:visible');
    const $nextItem = $('.s-home__seasons-item--' + season);

    // 同じアイテムがクリックされた場合は何もしない
    if ($currentItem.is($nextItem)) {
      return;
    }

    // ボタンの状態を更新
    $buttons.removeClass('active');
    $(this).addClass('active');

    // 初回表示時
    if ($currentItem.length === 0) {
      $nextItem.addClass('active').fadeIn(150);
      return;
    }

    // フェードアウト → フェードイン
    $currentItem.fadeOut(150, function () {
      $currentItem.removeClass('active');
      $nextItem.addClass('active').fadeIn(150);
    });
  });

  // 現在の月に応じて初期表示
  const currentSeason = getCurrentSeason();
  $(`.s-home__seasons-btn[data-season="${currentSeason}"]`).trigger('click');

  // // ボタン位置調整関数
  // function adjustButtonPosition() {
  //   adjustSlideButtonPosition(
  //     $('.s-home__seasons .s-home__slide.active'),
  //     '.c-slide__item',
  //     '.s-home__card-figure'
  //   );
  // }
  // return { adjustButtonPosition };
}
